import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {parseEntityDraftCardProps} from './entity-draft-card.library';
import {EntityDraftCard} from './entity-draft-card';

export const entityDraftCardRegistration = defineStreamComponentRegistration(StreamComponentType.ENTITY_DRAFT, EntityDraftCard, parseEntityDraftCardProps);
